// Mock data for Laboratorio Digital de Cine

export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Quiénes Somos', href: '#nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Tarifas', href: '#tarifas' },
  { label: 'Trabajos', href: '#trabajos' },
  { label: 'Contacto', href: '#contacto' },
];

export const heroData = {
  videoUrl: 'https://videos.pexels.com/video-files/4434286/4434286-uhd_2560_1440_30fps.mp4',
  fallbackImage: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?crop=entropy&cs=srgb&fm=jpg&q=85',
  badge: 'Carrier Oficial · Distribución Cinematográfica',
  title: 'El Carrier de Confianza para las',
  titleAccent: 'Distribuidoras Nacionales',
  subtitle:
    'Más de 10 años automatizando el envío de DCP, gestión de llaves KDM y logística de cartelería física con la máxima seguridad y tarifas altamente competitivas.',
  primaryCta: 'Solicitar Presupuesto Especial',
  secondaryCta: 'Ver Servicios',
};

export const impactStats = [
  {
    value: '+10',
    suffix: 'Años',
    label: 'de Experiencia en el Sector Cinematográfico',
  },
  {
    value: '100',
    suffix: '%',
    label: 'Salas de Cine Conectadas en España (Estándar DCI)',
  },
  {
    value: '24/7',
    suffix: '',
    label: 'Soporte Garantizado en Estrenos y Pases de Prensa',
  },
  {
    value: '+2.500',
    suffix: 'DCP',
    label: 'Películas Entregadas con Certificación Criptográfica',
  },
];

export const divisionBlocks = [
  {
    id: 'digital',
    tag: 'Vía Digital',
    title: 'Envío Electrónico',
    description:
      'Velocidad y encriptación instantánea a través de nuestra red CDN ultra rápida. Ingesta directa en cabina con estándar DCI sin manipulación física.',
    bullets: [
      'Transferencia cifrada AES-128',
      'Entrega en menos de 4 horas',
      'Confirmación automática de ingesta',
    ],
    image:
      'https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 'fisico',
    tag: 'Vía Física',
    title: 'Envío Físico',
    description:
      'Duplicación profesional de discos duros (copias DCP) y distribución capilar segura a salas sin conectividad idónea, con trazabilidad punto a punto.',
    bullets: [
      'Duplicación HDD certificada',
      'Distribución capilar nacional',
      'Trazabilidad GPS en tiempo real',
    ],
    image:
      'https://images.unsplash.com/photo-1535016120720-40c646be5580?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const guarantees = [
  {
    icon: 'ShieldCheck',
    title: 'Seguridad Criptográfica',
    text: 'KDM y encriptación AES bajo estándar DCI estricto.',
  },
  {
    icon: 'Headphones',
    title: 'Soporte 24/7 en Estrenos',
    text: 'Equipo técnico disponible en fin de semana y festivos.',
  },
  {
    icon: 'BadgeCheck',
    title: 'Estándar DCI Estricto',
    text: 'Compatibilidad total con servidores Doremi, Dolby, GDC y Qube.',
  },
  {
    icon: 'Zap',
    title: 'Ingesta Acelerada',
    text: 'Hasta 80% menos tiempo de carga en cabina vs. HDD tradicional.',
  },
];

export const aboutData = {
  title: 'Laboratorio Especializado en la Industria de la Exhibición Cinematográfica',
  intro:
    'Nacimos con un propósito claro: simplificar el puente técnico entre la distribución y la exhibición cinematográfica en el territorio nacional. Llevamos más de una década trabajando codo con codo con grandes y medianos distribuidores de cine, asegurando que cada copia llegue en perfectas condiciones y a tiempo para el pase de prensa o el gran estreno del viernes.',
  mission:
    'Ser el carrier definitivo y de referencia para las distribuidoras nacionales, unificando en una sola plataforma la logística digital y la física.',
  image:
    'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?crop=entropy&cs=srgb&fm=jpg&q=85',
  pillars: [
    {
      number: '01',
      title: 'Experiencia Probada',
      text: '10 años resolviendo las incidencias técnicas reales de las cabinas de proyección.',
    },
    {
      number: '02',
      title: 'Competitividad Extrema',
      text: 'Estructura de costes optimizada para ofrecer los precios más agresivos del mercado.',
    },
    {
      number: '03',
      title: 'Flexibilidad Híbrida',
      text: 'Combinamos la nube con el transporte terrestre clásico de cartelería y discos.',
    },
  ],
};

export const services = [
  {
    id: 1,
    code: 'S/01',
    icon: 'Film',
    title: 'Creación y Laboratorio de DCP y KDM',
    short: 'Masterización profesional al estándar DCI internacional.',
    description:
      'Antes del envío, preparamos vuestro contenido. Realizamos la masterización y codificación profesional de vuestros largometrajes, cortometrajes y piezas publicitarias al estándar internacional DCP (Digital Cinema Package). Asimismo, generamos el paquete maestro de seguridad para la protección de vuestros derechos de propiedad intelectual.',
    features: ['Encoding JPEG2000', 'Mastering 2K/4K HDR', 'Subtítulos DCI'],
    image:
      'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 2,
    code: 'S/02',
    icon: 'Cloud',
    title: 'Plataforma de Entrega Electrónica de DCP',
    short: 'Red CDN encriptada de velocidad ultra rápida.',
    description:
      'Contamos con una Red de Entrega de Contenidos (CDN) encriptada de velocidad ultra rápida que distribuye películas de estreno y trailers directamente a los servidores de los cines a través de banda ancha segura (estándar DCI). Este sistema inteligente disminuye drásticamente el uso de discos duros físicos (HDD) y agiliza los tiempos de ingesta en cabina.',
    features: ['CDN propietaria', 'Encriptación AES-128', 'Ingesta directa al servidor'],
    image:
      'https://images.unsplash.com/photo-1580106815433-a5b1d1d53d85?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 3,
    code: 'S/03',
    icon: 'KeyRound',
    title: 'Gestión Automatizada de Llaves KDM',
    short: 'Generación y envío automatizado de claves criptográficas.',
    description:
      'Implementamos herramientas críticas de seguridad digital. Nos encargamos de la automatización, generación, envío y actualización de las llaves criptográficas necesarias (Key Delivery Messages). De este modo, vuestras películas solo se reproducirán en los servidores de cine bajo las ventanas de tiempo y las pantallas estrictamente autorizadas por vuestro contrato de distribución.',
    features: ['KDM batch generation', 'Renovación automática', 'Dashboard de control'],
    image:
      'https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 4,
    code: 'S/04',
    icon: 'Radio',
    title: 'Retransmisión de Eventos en Directo · Plataforma Bravo',
    short: 'Streaming estable directo a salas para eventos en vivo.',
    description:
      'Llevamos los contenidos alternativos al siguiente nivel a través de nuestra plataforma propietaria Bravo. Ofrecemos una transmisión de señal totalmente estable vía streaming directo a las salas de cine para la exhibición de eventos en vivo de alto valor cultural, tales como ópera, ballet, conciertos filarmónicos o recitales exclusivos.',
    features: ['Latencia < 2s', 'Multi-cámara 4K', 'Backup satelital'],
    image:
      'https://images.unsplash.com/photo-1595769816263-9b910be24d5f?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 5,
    code: 'S/05',
    icon: 'Printer',
    title: 'Producción y Distribución de Cartelería Física',
    short: 'Impresión gran formato y distribución capilar a complejos.',
    description:
      'El marketing en el hall del cine sigue siendo clave. Cerramos el círculo logístico encargándonos de la producción, impresión a gran formato y posterior distribución capilar de toda la cartelería física, pósteres y displays comerciales directamente a los complejos cinematográficos asignados para la campaña.',
    features: ['Impresión 1.2m × 3m', 'Logística capilar', 'Displays retroiluminados'],
    image:
      'https://images.unsplash.com/photo-1536440136628-849c177e76a1?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const pricingRows = [
  {
    service: 'Creación de DCP',
    modality: 'Largometrajes / Cortos / Tráilers',
    rate: 'Tarifas a Medida',
    cta: 'Consultar Precio Especial',
  },
  {
    service: 'Envío de DCP',
    modality: 'Electrónico (Red CDN) o Físico (Copia HDD)',
    rate: 'Precios por Pantalla muy Competitivos',
    cta: 'Solicitar Cotización de Campaña',
  },
  {
    service: 'Gestión KDM',
    modality: 'Generación y Envío Automatizado',
    rate: 'Pack según volumen de salas',
    cta: 'Consultar Tarifas Especiales',
  },
  {
    service: 'Cartelería Física',
    modality: 'Producción Gráfica + Envío Logístico',
    rate: 'Presupuesto según volumen',
    cta: 'Solicitar Presupuesto Gráfico',
  },
  {
    service: 'Plataforma Bravo',
    modality: 'Streaming en Directo Multi-Sala',
    rate: 'Tarifa por evento y nº salas',
    cta: 'Consultar Disponibilidad',
  },
];

export const clients = [
  { name: 'Filmax Distribución', initials: 'FLX' },
  { name: 'Vértigo Films', initials: 'VTG' },
  { name: 'A Contracorriente Films', initials: 'ACF' },
  { name: 'BTeam Pictures', initials: 'BTM' },
  { name: 'Tripictures', initials: 'TRP' },
  { name: 'Sherlock Films', initials: 'SHL' },
  { name: 'Caramel Films', initials: 'CRM' },
  { name: 'Karma Films', initials: 'KRM' },
  { name: 'European Dreams', initials: 'EUD' },
  { name: 'Adso Films', initials: 'ADS' },
  { name: 'Wanda Films', initials: 'WND' },
  { name: 'Surtsey Films', initials: 'SUR' },
];

export const serviceOptions = [
  'Creación/Envío de DCP e Ingesta de KDM',
  'Distribución de Eventos en Directo (Plataforma Bravo)',
  'Producción y Envío de Cartelería Física',
  'Presupuesto integral para Estrenos de Campaña',
];

export const volumeOptions = [
  'Menos de 20 salas',
  'Entre 20 y 100 salas',
  'Más de 100 salas',
];

export const contactInfo = {
  email: 'comercial@labdigitalcine.es',
  phone: '+34 911 234 567',
  address: 'Calle Gran Vía 28, 28013 Madrid · España',
  hours: 'Lun-Vie 9:00 - 19:00 · Soporte estrenos 24/7',
};
